import axios from "axios";
import API_URLS from "../../config/global_variables";

const userData = localStorage.userData ? JSON.parse(localStorage.userData) : "";

const getAuthHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: userData.token,
});

const getCustomerByEmail = async (email) => {
  try {
    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: API_URLS.GET_CUSTOMER,
      headers: getAuthHeaders(),
      data: { email },
    };

    const response = await axios.request(config);

    if (response.status === 200) {
      return {
        success: true,
        data: response.data?.data ?? response.data ?? null,
        message: response.data?.message || "Customer fetched successfully",
      };
    }

    return {
      success: false,
      data: null,
      message: response.data?.message || "Failed to fetch customer",
    };
  } catch (error) {
    console.error("error", error);
    return {
      success: false,
      data: null,
      message:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch customer",
    };
  }
};

const updateCustomer = async (id, payload) => {
  try {
    const config = {
      method: "put",
      maxBodyLength: Infinity,
      url: API_URLS.UPDATE_CUSTOMER(id),
      headers: getAuthHeaders(),
      data: payload,
    };

    const response = await axios.request(config);

    if (response.status === 200 || response.status === 201) {
      return {
        success: true,
        data: response.data?.data ?? response.data ?? null,
        message: response.data?.message || "Customer updated successfully",
      };
    }

    return {
      success: false,
      data: null,
      message: response.data?.message || "Failed to update customer",
    };
  } catch (error) {
    console.error("error", error);
    return {
      success: false,
      data: null,
      message:
        error.response?.data?.message ||
        error.message ||
        "Failed to update customer",
    };
  }
};

const apiHelpers = {
  getCustomerByEmail,
  updateCustomer,
};

export default apiHelpers;
